<template>
  <el-row class="add-news">
    <el-col :span="12">
      {{ id ? "BudgetDocument hujjatini tahrirlash" : `BudgetDocument hujjati qo'shish` }}
    </el-col>

    <el-col :span="24">
      <el-form label-position="top" ref="formRef" :model="budgetDocumentModel">
        <el-tabs v-model="activeName">
          <el-tab-pane label="UZB" name="uz">
            <el-form-item
              label="Sarlavha"
              prop="titleUz"
              :rules="[{ required: true, message: 'Sarlavha majburiy (Uz)' }]"
            >
              <el-input
                placeholder="Sarlavhani kiriting (Uz)"
                v-model="budgetDocumentModel.titleUz"
                type="text"
                autocomplete="off"
              />
            </el-form-item>
            <el-form-item
              class="file-upload"
              label="Sarlavha uchun rasm"
              prop="imageUz"
              :rules="[
                {
                  required: true,
                  message: 'Sarlavha uchun rasm yuklang (Uz)',
                },
              ]"
            >
              <el-input
                hidden
                v-model.number="budgetDocumentModel.imageUz"
                type="text"
                autocomplete="off"
              />
              <input
                accept="image/jpeg, image/jpg, image/png"
                type="file"
                @change="uploadImgUz"
                hidden
                id="imgUz"
                ref="imgUploadRefUz"
              />
              <label
                for="imgUz"
                v-loading="imgLoaderUz"
                class="file-upload-button"
              >
                <div v-if="imgUrlUz">
                  <img :src="imgUrlUz" alt="" />
                </div>
                <div v-else>Sarlavha uchun rasm yuklash (Uz)</div>
              </label>
            </el-form-item>
            <el-form-item
              class="file-upload"
              label="Fayl"
              prop="fileUz"
              :rules="[
                {
                  required: true,
                  message: 'Fayl yuklang (Uz)',
                },
              ]"
            >
              <el-input
                hidden
                v-model.number="budgetDocumentModel.fileUz"
                type="text"
                autocomplete="off"
              />
              <input
                accept="application/pdf"
                type="file"
                @change="uploadFileUz"
                hidden
                id="fileUz"
                ref="uploadRefUz"
              />
              <label
                for="fileUz"
                v-loading="fileLoaderUz"
                class="file-upload-button"
              >
                <div v-if="fileNameUz">{{ fileNameUz }}</div>
                <div v-else>Fayl yuklash (Uz)</div>
              </label>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="UZB Krill" name="uzKr">
            <el-form-item
              label="Sarlavha"
              prop="titleUzKr"
              :rules="[{ required: true, message: 'Sarlavha majburiy (UzKr)' }]"
            >
              <el-input
                placeholder="Sarlavhani kiriting (UzKr)"
                v-model="budgetDocumentModel.titleUzKr"
                type="text"
                autocomplete="off"
              />
            </el-form-item>
            <el-form-item
              class="file-upload"
              label="Sarlavha uchun rasm"
              prop="imageUzKr"
              :rules="[
                {
                  required: true,
                  message: 'Sarlavha uchun rasm yuklang (UzKr)',
                },
              ]"
            >
              <el-input
                hidden
                v-model.number="budgetDocumentModel.imageUzKr"
                type="text"
                autocomplete="off"
              />
              <input
                accept="image/jpeg, image/jpg, image/png"
                type="file"
                @change="uploadImgUzKr"
                hidden
                id="imgUzKr"
                ref="imgUploadRefUzKr"
              />
              <label
                for="imgUzKr"
                v-loading="imgLoaderUzKr"
                class="file-upload-button"
              >
                <div v-if="imgUrlUzKr">
                  <img :src="imgUrlUzKr" alt="" />
                </div>
                <div v-else>Sarlavha uchun rasm yuklash (UzKr)</div>
              </label>
            </el-form-item>
            <el-form-item
              class="file-upload"
              label="Fayl"
              prop="fileUz"
              :rules="[
                {
                  required: true,
                  message: 'Fayl yuklang (UzKr)',
                },
              ]"
            >
              <el-input
                hidden
                v-model.number="budgetDocumentModel.fileUzKr"
                type="text"
                autocomplete="off"
              />
              <input
                accept="application/pdf"
                type="file"
                @change="uploadFileUzKr"
                hidden
                id="fileUzKr"
                ref="uploadRefUzKr"
              />
              <label
                for="fileUzKr"
                v-loading="fileLoaderUzKr"
                class="file-upload-button"
              >
                <div v-if="fileNameUzKr">{{ fileNameUzKr }}</div>
                <div v-else>Fayl yuklash (UzKr)</div>
              </label>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="RU" name="ru">
            <el-form-item
              label="Sarlavha"
              prop="titleRu"
              :rules="[{ required: true, message: 'Sarlavha majburiy (Ru)' }]"
            >
              <el-input
                placeholder="Sarlavhani kiriting (Ru)"
                v-model.number="budgetDocumentModel.titleRu"
                type="text"
                autocomplete="off"
              />
            </el-form-item>
            <el-form-item
              class="file-upload"
              label="Sarlavha uchun rasm"
              prop="imageRu"
              :rules="[
                {
                  required: true,
                  message: 'Sarlavha uchun rasm yuklang (Ru)',
                },
              ]"
            >
              <el-input
                hidden
                v-model.number="budgetDocumentModel.imageRu"
                type="text"
                autocomplete="off"
              />
              <input
                accept="image/jpeg, image/jpg, image/png"
                type="file"
                @change="uploadImgRu"
                hidden
                id="imgRu"
                ref="imgUploadRefRu"
              />
              <label
                for="imgRu"
                v-loading="imgLoaderRu"
                class="file-upload-button"
              >
                <div v-if="imgUrlRu">
                  <img :src="imgUrlRu" alt="" />
                </div>
                <div v-else>Sarlavha uchun rasm yuklash (Ru)</div>
              </label>
            </el-form-item>
            <el-form-item
              class="file-upload"
              label="Fayl"
              prop="fileRu"
              :rules="[
                {
                  required: true,
                  message: 'Fayl yuklang (Ru)',
                },
              ]"
            >
              <el-input
                hidden
                v-model.number="budgetDocumentModel.fileRu"
                type="text"
                autocomplete="off"
              />
              <input
                accept="application/pdf"
                type="file"
                @change="uploadFileRu"
                hidden
                id="fileRu"
                ref="uploadRefRu"
              />
              <label
                for="fileRu"
                v-loading="fileLoaderRu"
                class="file-upload-button"
              >
                <div v-if="fileNameRu">{{ fileNameRu }}</div>
                <div v-else>Fayl yuklash (Ru)</div>
              </label>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="ENG" name="en">
            <el-form-item
              label="Sarlavha (En)"
              prop="titleEn"
              :rules="[{ required: true, message: 'Sarlavha majburiy (En)' }]"
            >
              <el-input
                placeholder="Sarlavhani kiriting (En)"
                v-model.number="budgetDocumentModel.titleEn"
                type="text"
                autocomplete="off"
              />
            </el-form-item>
            <div class="mt-15 form-row">
              <el-form-item
                class="file-upload"
                label="Sarlavha uchun rasm"
                prop="imageEn"
                :rules="[
                  {
                    required: true,
                    message: 'Sarlavha uchun rasm yuklang (En)',
                  },
                ]"
              >
                <el-input
                  hidden
                  v-model.number="budgetDocumentModel.imageEn"
                  type="text"
                  autocomplete="off"
                />
                <input
                  accept="image/jpeg, image/jpg, image/png"
                  type="file"
                  @change="uploadImgEn"
                  hidden
                  id="imgEn"
                  ref="imgUploadRefEn"
                />
                <label
                  for="imgEn"
                  v-loading="imgLoaderEn"
                  class="file-upload-button"
                >
                  <div v-if="imgUrlEn">
                    <img :src="imgUrlEn" alt="" />
                  </div>
                  <div v-else>Sarlavha uchun rasm yuklash (En)</div>
                </label>
              </el-form-item>
            </div>
            <el-form-item
              class="file-upload"
              label="Fayl"
              prop="fileEn"
              :rules="[
                {
                  required: true,
                  message: 'Fayl yuklang (En)',
                },
              ]"
            >
              <el-input
                hidden
                v-model.number="budgetDocumentModel.fileEn"
                type="text"
                autocomplete="off"
              />
              <input
                accept="application/pdf"
                type="file"
                @change="uploadFileEn"
                hidden
                id="fileEn"
                ref="uploadRefEn"
              />
              <label
                for="fileEn"
                v-loading="fileLoaderEn"
                class="file-upload-button"
              >
                <div v-if="fileNameEn">{{ fileNameEn }}</div>
                <div v-else>Fayl yuklash (En)</div>
              </label>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="KP" name="kp">
            <el-form-item
              label="Sarlavha (Kp)"
              prop="titleKp"
              :rules="[{ required: true, message: 'Sarlavha majburiy (Kp)' }]"
            >
              <el-input
                placeholder="Sarlavhani kiriting (Kp)"
                v-model.number="budgetDocumentModel.titleKp"
                type="text"
                autocomplete="off"
              />
            </el-form-item>
            <div class="mt-15 form-row">
              <el-form-item
                class="file-upload"
                label="Sarlavha uchun rasm"
                prop="imageKp"
                :rules="[
                  {
                    required: true,
                    message: 'Sarlavha uchun rasm yuklang (Kp)',
                  },
                ]"
              >
                <el-input
                  hidden
                  v-model.number="budgetDocumentModel.imageKp"
                  type="text"
                  autocomplete="off"
                />
                <input
                  accept="image/jpeg, image/jpg, image/png"
                  type="file"
                  @change="uploadImgKp"
                  hidden
                  id="imgKp"
                  ref="imgUploadRefKp"
                />
                <label
                  for="imgKp"
                  v-loading="imgLoaderKp"
                  class="file-upload-button"
                >
                  <div v-if="imgUrlKp">
                    <img :src="imgUrlKp" alt="" />
                  </div>
                  <div v-else>Sarlavha uchun rasm yuklash (Kp)</div>
                </label>
              </el-form-item>
            </div>
            <el-form-item
              class="file-upload"
              label="Fayl"
              prop="fileKp"
              :rules="[
                {
                  required: true,
                  message: 'Fayl yuklang (Kp)',
                },
              ]"
            >
              <el-input
                hidden
                v-model.number="budgetDocumentModel.fileKp"
                type="text"
                autocomplete="off"
              />
              <input
                accept="application/pdf"
                type="file"
                @change="uploadFileKp"
                hidden
                id="fileKp"
                ref="uploadRefKp"
              />
              <label
                for="fileKp"
                v-loading="fileLoaderKp"
                class="file-upload-button"
              >
                <div v-if="fileNameKp">{{ fileNameKp }}</div>
                <div v-else>Fayl yuklash (Kp)</div>
              </label>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
        <div class="mt-15 text-right">
          <router-link
            to="/app/budget-document"
            class="el-button el-button--danger"
          >
            Bekor qilish
          </router-link>
          <el-button type="primary" @click="submitForm(formRef)"
            >Saqlash</el-button
          >
        </div>
      </el-form>
    </el-col>
  </el-row>
</template>

<script setup>
import { onMounted, reactive, ref } from "vue";
import { ElMessage } from "element-plus";
import store from "@/store";
import http from "@/http";
import router from "@/router";
import { useRoute } from "vue-router";

const baseUrl = process.env.VUE_APP_BASE_API_URL + "/api/v2/info/file/";
const formRef = ref();
const loading = ref(false);
const imgUrlUz = ref(null);
const imgUrlUzKr = ref(null);
const imgUrlRu = ref(null);
const imgUrlEn = ref(null);
const imgUrlKp = ref(null);
const fileNameUz = ref(null);
const fileNameUzKr = ref(null);
const fileNameRu = ref(null);
const fileNameEn = ref(null);
const fileNameKp = ref(null);
const imgLoaderUz = ref(false);
const imgLoaderUzKr = ref(false);
const fileLoaderUz = ref(false);
const fileLoaderUzKr = ref(false);
const imgLoaderRu = ref(false);
const fileLoaderRu = ref(false);
const imgLoaderEn = ref(false);
const fileLoaderEn = ref(false);
const imgLoaderKp = ref(false);
const fileLoaderKp = ref(false);
const activeName = ref("uz");
const route = useRoute();
const { id } = route.params;
const budgetDocumentModel = reactive({
  titleUz: "",
  titleUzKr: "",
  titleRu: "",
  titleEn: "",
  titleKp: "",
  imageUz: "",
  imageUzKr: "",
  imageRu: "",
  imageEn: "",
  imageKp: "",
  fileUz: "",
  fileUzKr: "",
  fileRu: "",
  fileEn: "",
  fileKp: "",
});
const attachments = reactive([]);
const images = reactive([]);

const uploadImgUz = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    const fileValidate = beforeUploadFile(file);

    if (fileValidate) {
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          imgUrlUz.value = baseUrl + data.hashId;
          budgetDocumentModel.imageUz = data.hashId;
          images.push({
            file_id: data.hashId,
            lang: "uz_lat",
            type: "IMAGE",
          });
          resolve(imgUrlUz);
        })
        .catch((err) => {
          resolve(`Rasm yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          imgLoaderUz.value = false;
        });
    } else {
      reject("");
    }
  });
};
const uploadImgUzKr = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    const fileValidate = beforeUploadFile(file);

    if (fileValidate) {
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          imgUrlUzKr.value = baseUrl + data.hashId;
          budgetDocumentModel.imageUzKr = data.hashId;
          images.push({
            file_id: data.hashId,
            lang: "uz_cyr",
            type: "IMAGE",
          });
          resolve(imgUrlUzKr);
        })
        .catch((err) => {
          resolve(`Rasm yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          imgLoaderUzKr.value = false;
        });
    } else {
      reject("");
    }
  });
};
const uploadImgRu = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    const fileValidate = beforeUploadFile(file);

    if (fileValidate) {
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          imgUrlRu.value = baseUrl + data.hashId;
          budgetDocumentModel.imageRu = data.hashId;
          images.push({
            file_id: data.hashId,
            lang: "ru",
            type: "IMAGE",
          });
          resolve(imgUrlRu);
        })
        .catch((err) => {
          resolve(`Rasm yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          imgLoaderRu.value = false;
        });
    } else {
      reject("");
    }
  });
};
const uploadImgEn = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    const fileValidate = beforeUploadFile(file);

    if (fileValidate) {
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          imgUrlEn.value = baseUrl + data.hashId;
          budgetDocumentModel.imageEn = data.hashId;
          images.push({
            file_id: data.hashId,
            lang: "en",
            type: "IMAGE",
          });
          resolve(imgUrlEn);
        })
        .catch((err) => {
          resolve(`Rasm yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          imgLoaderEn.value = false;
        });
    } else {
      reject("");
    }
  });
};
const uploadImgKp = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    const fileValidate = beforeUploadFile(file);

    if (fileValidate) {
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          imgUrlKp.value = baseUrl + data.hashId;
          budgetDocumentModel.imageKp = data.hashId;
          images.push({
            file_id: data.hashId,
            lang: "kr",
            type: "IMAGE",
          });
          resolve(imgUrlKp);
        })
        .catch((err) => {
          resolve(`Rasm yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          imgLoaderKp.value = false;
        });
    } else {
      reject("");
    }
  });
};

const uploadFileUz = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    const fileValidate = beforeUploadFile(file);
    fileNameUz.value = file.name;
    if (fileValidate) {
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          budgetDocumentModel.fileUz = data.hashId;
          attachments.push({
            file_id: data.hashId,
            lang: "uz_lat",
            type: "ATTACHMENT",
          });
        })
        .catch((err) => {
          resolve(`Fayl yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          fileLoaderUz.value = false;
        });
    } else {
      reject("");
    }
  });
};
const uploadFileUzKr = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    const fileValidate = beforeUploadFile(file);
    fileNameUzKr.value = file.name;
    if (fileValidate) {
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          budgetDocumentModel.fileUzKr = data.hashId;
          attachments.push({
            file_id: data.hashId,
            lang: "uz_cyr",
            type: "ATTACHMENT",
          });
        })
        .catch((err) => {
          resolve(`Fayl yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          fileLoaderUzKr.value = false;
        });
    } else {
      reject("");
    }
  });
};
const uploadFileRu = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    fileNameRu.value = file.name;
    const fileValidate = beforeUploadFile(file);

    if (fileValidate) {
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          budgetDocumentModel.fileRu = data.hashId;
          attachments.push({
            file_id: data.hashId,
            lang: "ru",
            type: "ATTACHMENT",
          });
        })
        .catch((err) => {
          resolve(`Fayl yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          fileLoaderRu.value = false;
        });
    } else {
      reject("");
    }
  });
};
const uploadFileEn = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    fileNameEn.value = file.name;
    const fileValidate = beforeUploadFile(file);

    if (fileValidate) {
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          budgetDocumentModel.fileEn = data.hashId;
          attachments.push({
            file_id: data.hashId,
            lang: "en",
            type: "ATTACHMENT",
          });
        })
        .catch((err) => {
          resolve(`Fayl yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          fileLoaderEn.value = false;
        });
    } else {
      reject("");
    }
  });
};

const uploadFileKp = (event) => {
  return new Promise((resolve, reject) => {
    const file = event.target.files[0];
    fileNameKp.value = file.name;
    const fileValidate = beforeUploadFile(file);

    if (fileValidate) {
      const formData = new FormData();
      formData.append("file", file);
      const url = `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`;
      http
        .post(url, formData, {
          headers: {
            Authorization: store.state.accessToken,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          budgetDocumentModel.fileKp = data.hashId;
          attachments.push({
            file_id: data.hashId,
            lang: "kr",
            type: "ATTACHMENT",
          });
        })
        .catch((err) => {
          resolve(`Fayl yuklash bilan bog'liq hatolik. Qayta urinib ko'ring!`);
          console.log(err);
        })
        .finally(() => {
          fileLoaderKp.value = false;
        });
    } else {
      reject("");
    }
  });
};

const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      loading.value = true;
      http({
        url: `api/v1/posts/budget-document${id ? `/${id}` : ""}`,
        data: {
          title: {
            uz_lat: budgetDocumentModel.titleUz,
            uz_cyr: budgetDocumentModel.titleUzKr,
            ru: budgetDocumentModel.titleRu,
            en: budgetDocumentModel.titleEn,
            kr: budgetDocumentModel.titleKp,
          },
          attachments,
          images,
        },
        method: id ? "put" : "post",
        headers: {},
      })
        .then(() => {
          router.push("/app/budget-document");
        })
        .catch((err) => {
          console.log(err);
          ElMessage.error(`Xatolik qayta urinib ko'ring`);
        })
        .finally(() => {
          loading.value = false;
        });
    } else {
      const errors = [];
      for (const keys in fields) {
        fields[keys].map((item) => {
          errors.push(item);
        });
      }
      errors.map((error) => {
        ElMessage.error(error.message);
      });
      console.log("error submit!", fields);
    }
  });
};
const beforeUploadFile = (rawFile) => {
  if (!rawFile) {
    return false;
  }
  if (
    rawFile.type !== "image/jpeg" &&
    rawFile.type !== "image/png" &&
    rawFile.type !== "image/jpg" &&
    rawFile.type !== "application/pdf"
  ) {
    ElMessage.error(`Sarlavha uchun rasm JPG, JPEG, PNG bo'lishi mumkin!`);
    return false;
  }
  if (rawFile.size / 1024 / 1024 > 5) {
    ElMessage.error(`Sarlavha uchun rasm xajmi max. 5Mb bo'lishi kerak!`);
    return false;
  }
  return true;
};
onMounted(() => {
  if (id) {
    http.get(`api/v1/posts/budget-document/${id}`).then(({ data }) => {
      budgetDocumentModel.titleUz = data.title?.uz_lat;
      budgetDocumentModel.titleUzKr = data.title?.uz_cyr;
      budgetDocumentModel.titleRu = data.title?.ru;
      budgetDocumentModel.titleEn = data.title?.en;
      budgetDocumentModel.titleKp = data.title?.kr;

      for (let img of data.images) {
        if (img.lang === "uz_lat") {
          budgetDocumentModel.imageUz = img.file_id;
          imgUrlUz.value = baseUrl + img.file_id;
        }
        if (img.lang === "uz_cyr") {
          budgetDocumentModel.imageUzKr = img.file_id;
          imgUrlUzKr.value = baseUrl + img.file_id;
          images.push({
            file_id: img.file_id,
            lang: "uz_cyr",
            type: "IMAGE",
          });
        }
        if (img.lang === "ru") {
          budgetDocumentModel.imageRu = img.file_id;
          imgUrlRu.value = baseUrl + img.file_id;
          images.push({
            file_id: img.file_id,
            lang: "ru",
            type: "IMAGE",
          });
        }
        if (img.lang === "en") {
          budgetDocumentModel.imageEn = img.file_id;
          imgUrlEn.value = baseUrl + img.file_id;
          images.push({
            file_id: img.file_id,
            lang: "en",
            type: "IMAGE",
          });
        }
        if (img.lang === "kr") {
          budgetDocumentModel.imageKp = img.file_id;
          imgUrlKp.value = baseUrl + img.file_id;
          images.push({
            file_id: img.file_id,
            lang: "kr",
            type: "IMAGE",
          });
        }
      }
      for (let attachment of data.attachments) {
        if (attachment.lang === "uz_lat") {
          budgetDocumentModel.fileUz = attachment.file_id;
          attachments.push({
            file_id: attachment.file_id,
            lang: "uz_lat",
            type: "ATTACHMENT",
          });
        }
        if (attachment.lang === "uz_cyr") {
          budgetDocumentModel.fileUzKr = attachment.file_id;
          attachments.push({
            file_id: attachment.file_id,
            lang: "uz_cyr",
            type: "ATTACHMENT",
          });
        }
        if (attachment.lang === "ru") {
          budgetDocumentModel.fileRu = attachment.file_id;
          attachments.push({
            file_id: attachment.file_id,
            lang: "ru",
            type: "ATTACHMENT",
          });
        }
        if (attachment.lang === "en") {
          budgetDocumentModel.fileEn = attachment.file_id;
          attachments.push({
            file_id: attachment.file_id,
            lang: "en",
            type: "ATTACHMENT",
          });
        }
        if (attachment.lang === "kr") {
          budgetDocumentModel.fileKp = attachment.file_id;
          attachments.push({
            file_id: attachment.file_id,
            lang: "kr",
            type: "ATTACHMENT",
          });
        }
      }
    });
  }
});
</script>

<style>
.file-upload label {
  margin: 0 !important;
}

.add-news .el-input__wrapper {
  padding: 0 1rem !important;
}

.input-hidden .el-form-item__content {
  height: 0;
  padding: 0;
}
</style>
<style scoped lang="scss">
.linkButtons {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
  width: 450px;
  button {
    width: 100%;
  }
}

.file-upload-button {
  padding: 1rem;
  border: 1px dotted #e1e1e1;
  border-radius: 8px;
  overflow: hidden;
  color: #808080;
  display: block;
  max-width: 240px;
  cursor: pointer;

  &:hover {
    background-color: #e1e1e1;
  }

  img {
    max-width: 100%;
    object-fit: cover;
  }
}

.text-right {
  text-align: right;
}

a {
  text-decoration: none;
}

.form-row {
  display: flex;
  gap: 15px;
}
</style>
